import React from "react";
import { useEffect } from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm ,Controller} from "react-hook-form";
import Axios from "axios";
import { useState } from 'react';
import LoadingSpinner from "../helpers/loadingspinner";
import { Link,useNavigate } from "react-router-dom";
import { AddCandidateIntSchDet, GetJobPosts, GetJobRoles, GetTestTypes } from "../apiconstants/constants";
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Select from 'react-select';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useCountry } from "../contexts/countrycodecontext.js";

const ConfigureIntitialScreeningTest = ()=>{
      const { register, handleSubmit,formState,control,reset,watch,setValue} = useForm({
  defaultValues: {
    isVideoRequired: "True",
    isCustomQuestionsRequired: "False",
    //  testTypeID: '4',
     questionsCount:'5',
     time:'10',
  },
});
    const { errors } = formState
    const { isSubmitting } = formState;
    const navigate=useNavigate();
    const [isDisabled, setIsDisabled] = useState(false);
    const [jobRoles,SetJobRoles]=useState([{}]);
    var apiUrl = {};
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCandidates, setSelectedCandidates] = useState();
    const { selectedCountry} = useCountry();
    const [duration,setDuration] = useState([
      {durationID:"5",durationValue:"5"},
      {durationID:"10",durationValue:"10"},
      {durationID:"15",durationValue:"15"},
      {durationID:"20",durationValue:"20"},
      {durationID:"25",durationValue:"25"},
      {durationID:"30",durationValue:"30"}])
      const [questions,setQuestions] = useState([
        {questionID:"1",questionValue:"1"},
        {questionID:"2",questionValue:"2"},
        {questionID:"3",questionValue:"3"},
        {questionID:"4",questionValue:"4"},
        {questionID:"5",questionValue:"5"},
        {questionID:"6",questionValue:"6"},
        {questionID:"7",questionValue:"7"},
        {questionID:"8",questionValue:"8"},
        {questionID:"9",questionValue:"9"},
        {questionID:"10",questionValue:"10"}])
      const [testTypes, setTestTypes] = useState([]);
          const [jobPosts, setJobPosts] = useState([]);
      
      let Guid="";
      const guid = localStorage.getItem("guid");
      const employerGuid = localStorage.getItem("employerGuid")
      const email = localStorage.getItem("email")
      const token = localStorage.getItem("jwtToken");
      const roleID = localStorage.getItem("roleID")
      
      if(roleID==3){
       Guid = employerGuid
      }
      else{
        Guid= guid
      }
    const FetchJobroles=()=>
      {
        const GetapiUrl=`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        const fetchJSON = async () => {
          const response = await fetch(GetapiUrl);
          let json = await response.json();
          SetJobRoles(json);
        }
        fetchJSON();
    }

       const fetchJobPosts = async () => {
            setIsLoading(true);
            try {
                const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
                  { headers: { Authorization: `Bearer ${token}` } }
                );
               const filteredJobPosts = response.data?.filter((x)=>x.status=='Active')
                setJobPosts(filteredJobPosts);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching job posts", error);
                setIsLoading(false);
            }
        };

    const fetchTestTypes = () => {
      const getTestTypesUrl = GetTestTypes.APIURL;
      Axios.get(getTestTypesUrl,{headers: { Authorization: `Bearer ${token}` } }).then((response) => {
          setTestTypes(response.data);
      }).catch((error) => {
          console.error("Error fetching test types", error);
      });
  };


const useremail = localStorage.getItem("email")

const onSubmit = (data,e) => {
  console.log(data)
        e.target.reset();
        reset();
        setIsLoading(true);
        AddData(data)
    
    }
        const AddData = async (data) => {
          console.log(data)
        setIsLoading(true);
        const JobRole = data.JobRole.value;
        const testTypeID = data.testTypeID; 
  const startDate = data.startdate;
  const endDate = data.enddate;
  const time = Number(data.time);
  const questionsCount = data.questionsCount;
  const jobDescription = data.jobDescription;
  const isVideoRequired = JSON.parse( data.isVideoRequired.toLowerCase());
  const isCustomQuestionsRequired = JSON.parse( data.isCustomQuestionsRequired?.toLowerCase());

 
  const candidates = selectedCandidates.map((person) => ({
    employerGuid: Guid,
     email: person.email,
     candidatesID:person.candidatesID,
     jobRoleID: JobRole,
     testTypeID: testTypeID,
    startDate: startDate,
    endDate: endDate,
    time: time,
    questionsCount:questionsCount,
    createdBy: useremail,
    jobDescription : jobDescription,
    isVideoRequired:isVideoRequired,
    iscustomQuestionsRequired: isCustomQuestionsRequired
  }));
      
    apiUrl = AddCandidateIntSchDet.APIURL;
    Axios.post(apiUrl, candidates)
      .then((result) => {
         setIsLoading(false)

     const messages = result.data.message;
    if (Array.isArray(messages)) {
      const successList = [];
      const failureList = [];

      messages.forEach((msg, index) => {
        const email = selectedCandidates[index]?.email || 'Unknown Email';
        if (msg === 'Job seekers added successfully') {
          successList.push(`✅ ${email} - Configured successfully`);
        } else {
          failureList.push(`❌ ${email} - ${msg}`);
        }
      });

      const successHtml = successList.length > 0
        ? `<strong>Configured:</strong><br>${successList.join('<br>')}<br><br>`
        : '';

      const failureHtml = failureList.length > 0
        ? `<strong>Failed:</strong><br>${failureList.join('<br>')}`
        : '';

      const finalHtml = successHtml + failureHtml;

      const iconType = failureList.length === 0
        ? 'success'
        : successList.length === 0
          ? 'error'
          : 'warning';

      const titleText = failureList.length === 0
        ? 'All Tests Configured Successfully'
        : successList.length === 0
          ? 'All Tests Configuring Failed'
          : 'Some Candidates Tests Configured Successfully';

      Swal.fire({
        icon: iconType,
        title: titleText,
        html: finalHtml,
        width: 600,
        confirmButtonText: 'OK'
      });

      if (successList.length > 0) {
        navigate("/Employer/NonHiredCandidates");
        localStorage.removeItem('selectedCandidates');
        setSelectedCandidates([]);
      }
    }
        }).catch(
        function (error) {
          console.log("Error" + error)
        })
       
      }
      const jobRoleOptions = jobRoles.map((item) => ({
        value: item.jobRoleId,
        label: item.jobRole
      }));

      const jobPostOptions = jobPosts.map(job => ({
        label: job.title,
        value: job.jobPostID,
        jobDescription: job.jobDescription // Store job description for later use
      }));
      const selectedJobPostID = watch("jobPost")?.value;
      const selectedJobRoleID = watch("JobRole")?.value;
      
      const filteredJobPosts = jobPosts.filter(job => job.jobRoleID == selectedJobRoleID);
      
      const jobTitleOptions = filteredJobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));
      
      const selectedJob = filteredJobPosts.find(job => job.jobPostID == selectedJobPostID);
      
      useEffect(() => {
        if (selectedJob) {
          setValue("jobDescription", selectedJob.jobDescription);
        } else {
          setValue("jobDescription", ""); // Reset if no job selected
        }
      }, [selectedJob, setValue, filteredJobPosts]);
      
    useEffect(() => {
  const today = new Date();
  const twoDaysLater = new Date();
  twoDaysLater.setDate(today.getDate() + 2);

  const formattedToday = today.toISOString().split('T')[0];
  const formattedEndDate = twoDaysLater.toISOString().split('T')[0];

  setValue("startdate", formattedToday);
  setValue("enddate", formattedEndDate);
  if (testTypes.length > 0) {
    setValue("testTypeID", 4); // set default to ID 4
  }
}, [setValue,testTypes]);
  
    
      useEffect(() => {
        const candidatesFromStorage = JSON.parse(localStorage.getItem('selectedCandidates')) || [];
        setSelectedCandidates(candidatesFromStorage);
        FetchJobroles();
        fetchTestTypes();
        fetchJobPosts();
      }, [selectedCountry]);
 return(
<ConsultantLayout>
  <section>
  {
  isLoading ? <center> <LoadingSpinner /> </center> : 
  <div className="container-fluid mt-4 pb-5">
                       <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/NonHiredCandidates">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Configure Screening Test</h2>
</div> 
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
        <form onSubmit={handleSubmit(onSubmit)} id="loginform">
        <table className="table table-striped">

                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Email</th>
                        </tr>
                      </thead>
                      <tbody>
  {selectedCandidates?.map((name, index) => (
    <tr key={index}>
      <td>{name.fullName}</td>
      <td>{name.email}</td>
    </tr>
  ))}
</tbody>

                    </table>
       <div class="row p-3">

<div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>
  )}
>
  <div className="mt-3">
  <Controller
  name="JobRole"
  control={control}
  rules={{ required: "Job Role is required" }}
  render={({ field }) => (
    <Select
      {...field}
      options={jobRoleOptions}
      placeholder="Select Job Role"
      styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 15,
          borderColor: errors.JobRole ? 'red' : provided.borderColor
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999, // Ensures dropdown appears above everything
          position: "absolute" // Fixes layout issues
        })
      }}
      onChange={(selectedOption) => {
        field.onChange(selectedOption);
        setValue("jobPost", null); // Reset job title when job role changes
        setValue("jobDescription", ""); // Reset job description
      }}
      className={`basic-form ${errors.JobRole ? 'is-invalid' : ''}`}
    />
  )}
/>
{errors.JobRole && <div className="invalid-feedback d-block">{errors.JobRole.message}</div>}

  </div>
</OverlayTrigger>

<OverlayTrigger
  placement="bottom"
  overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Post</Tooltip>}
>
  <div className="mt-4">
    <Controller
      name="jobPost"
      control={control}
      rules={{ required: "Job Post is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobTitleOptions}
          placeholder="Select Job Post"
          className={`basic-form ${errors.jobPost ? 'is-invalid' : ''}`}
          styles={{
            control: (provided) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              borderColor: errors.jobPost ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
         
      
          // Store the entire selected option object
          onChange={(selectedOption) => {
            field.onChange(selectedOption); // Save the full selected option
            setValue("jobDescription", selectedOption.jobDescription); // Set job description
          }}
          value={jobPostOptions.find(option => option.value === field.value)}
        />
      )}
    />
    {errors.jobPost && <div className="invalid-feedback d-block">{errors.jobPost.message}</div>}
  </div>
</OverlayTrigger>


  <label style={{color:"#00a7ac", marginTop:10}}>Job Description</label>
  <Controller
          control={control}
          name="jobDescription"
          rules={{
            required: { value: true, message: "Job Description Required" },
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <div>
              <WYSIWYGEditor
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                ref={ref}
                inputExtraProps={{
                  required: true,
                }}
              />
              {errors.jobDescription && (
                <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                  {errors.jobDescription.message}
                </p>
              )}
            </div>
          )}
        />

<OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Test Type</Tooltip>)}>
                                                    <select {...register("testTypeID", { required: "Test Type Required" })} className={`form-control basic-form mt-3 ${errors.testTypeID ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }} defaultValue="4">
                                                        <option value="">Select Test Type</option>
                                                        {
                                                            testTypes.map((item, index) => (
                                                                <option key={index} value={item.testTypeID}>{item.testType}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </OverlayTrigger>
                                                <div className="invalid-feedback"> {errors.testTypeID?.message}</div>

        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Start date</Tooltip>)}>
        <input type="date" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"   name="startdate"
         {...register("startdate", { required: "Start Date Required" })}
         disabled={isDisabled}
           className={`form-control basic-form mt-3 `} placeholder="Date of birth" aria-label="startdate"/>
        </OverlayTrigger>
        <div className="invalid-feedback"> {errors.startdate?.message}</div>
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> End Date</Tooltip>)}>
        <input type="date" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"   name="enddate"
         {...register("enddate", { required: "End Date Required" })}
         disabled={isDisabled}
           className={`form-control basic-form mt-3 `} placeholder="Date of birth" aria-label="enddate"/>
        </OverlayTrigger>
        <div className="invalid-feedback"> {errors.enddate?.message}</div>
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Number of Questions</Tooltip>)}>    

<select  {...register("questionsCount", { required: "Question Count Required" })} className={`form-control basic-form mt-3 ${errors.questionsCount ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Number of Questions </option>
{
questions.map((item,index)=>
{
return(

<option key={index}  value={item.questionValue}>{item.questionValue}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.questionsCount?.message}</div> }
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Duration</Tooltip>)}>    

<select  {...register("time", { required: "Duration Required" })} className={`form-control basic-form mt-3 ${errors.time ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Time Duration </option>
{
duration.map((item,index)=>
{
return(

<option key={index}  value={item.durationValue}>{item.durationValue}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.time?.message}</div> }


          <label className="mt-3 mr-3" style={{color:"#00a7ac"}} >Video Required?</label>
          <input 
        {...register("isVideoRequired", { required: true })}
        type="radio"
        name="isVideoRequired"
        value="True"
        id="field-male"
        disabled={isDisabled}
      /> 
      <label style={{ fontSize: 13, color: "#495057",marginRight:24, marginLeft: 6 }}>Yes</label>
      
      <input  
        {...register("isVideoRequired", { required: true })}
        type="radio"
        name="isVideoRequired"
        value="False"
        id="field-female"
        disabled={isDisabled}
      />
      <label style={{ fontSize: 13, color: "#495057", marginLeft: 6 }}>No</label>
      
      {errors.isVideoRequired && <div style={{color:"#dc3545",fontSize:"80%"}}>Select Yes or No</div>}
      <div>
  <label className="mt-3 mr-3" style={{ color: "#00a7ac" }}>Custom Questions Required?</label>
  
  <input 
    {...register("isCustomQuestionsRequired", { required: true })} // Fixed casing
    type="radio"
    name="isCustomQuestionsRequired"
    value="True"
    id="field-question-true" // Unique ID
    disabled={isDisabled}
  /> 
  <label style={{ fontSize: 13, color: "#495057", marginRight: 24, marginLeft: 6 }}>Yes</label>

  <input  
    {...register("isCustomQuestionsRequired", { required: true })}
    type="radio"
    name="isCustomQuestionsRequired"
    value="False"
    id="field-question-false" // Unique ID
    disabled={isDisabled}
  />
  <label style={{ fontSize: 13, color: "#495057", marginLeft: 6 }}>No</label>

  {errors.isCustomQuestionsRequired && <div style={{ color: "#dc3545", fontSize: "80%" }}>Select Yes or No</div>}
</div>

</div>
</div>  
  
         
    <div class="row mb-4 mt-3 ">
    <div class="col-12">  
    
            
               </div>
               </div>
               <Link to="/Employer/NonHiredCandidates"> 
                <button  style={{float:"right"}}   disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
                
       <button id="svbutton" style={{float:"right"}} disabled={isSubmitting || isDisabled } className="btn btn-primary pf-save mb-3 mr-3" >
                     {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                     Configure Test
                 </button> &nbsp;&nbsp;&nbsp;
     
     </form>
    </div>

   </div>

</div>

 }

 </section>

</ConsultantLayout>

    )
}
export default ConfigureIntitialScreeningTest;